// Canonical list of services a shop can advertise, grouped for the UI.
//
// Unlike vehicle makes (free-form, fetched from `/makes`), this is a fixed curated list.
// The backend enforces the same allowlist in `backend/utils/shop_services.py` - the two
// MUST stay identical; update both in the same change. No en/em dashes per repo convention.

export const SHOP_SERVICE_GROUPS = [
  {
    label: "Maintenance",
    services: [
      "Oil changes and routine maintenance",
      "Tune-ups",
      "Tires",
      "Wheel alignment",
      "Batteries and charging systems",
    ],
  },
  {
    label: "Brakes and Suspension",
    services: ["Brakes", "Suspension and steering"],
  },
  {
    label: "Engine and Drivetrain",
    services: [
      "Engine repair and diagnostics",
      "Transmission repair",
      "Exhaust and mufflers",
      "Clutch and driveline",
    ],
  },
  {
    label: "Electrical and Climate",
    services: [
      "Electrical and wiring",
      "Heating and air conditioning (A/C)",
      "Check-engine light diagnostics",
    ],
  },
  {
    label: "Specialty",
    services: [
      "Diesel repair",
      "Hybrid and EV service",
      "Pre-purchase inspections",
      "State inspection and emissions",
    ],
  },
];

// Flat list of all valid service labels, in canonical order.
export const SHOP_SERVICE_OPTIONS = SHOP_SERVICE_GROUPS.flatMap((g) => g.services);

const CANONICAL_BY_LOWER = new Map(SHOP_SERVICE_OPTIONS.map((s) => [s.toLowerCase(), s]));

// Trim, dedupe, and keep only allowlisted services in canonical casing/order. Mirrors the
// backend `clean_services` so the client sends already-clean values.
export function cleanServices(values) {
  if (!Array.isArray(values)) return [];
  const keep = new Set();
  for (const raw of values) {
    const canonical = CANONICAL_BY_LOWER.get(String(raw || "").trim().toLowerCase());
    if (canonical) keep.add(canonical);
  }
  return SHOP_SERVICE_OPTIONS.filter((s) => keep.has(s));
}
